import _ from 'lodash';
import React from 'react';
import AddFormProto from "app/quick-add/sections/project/form/new-project-form-proto.tsx";

import Form from '../../../../../../core/gd-form/form/deprecated/form-add/form-add';
import FormManager from 'src/core/gd-form/common/form-manager';

import Api from '../../../../../../core/gd/api/api';
import {newProject_getFormFieldsProto} from "app/quick-add/sections/project/form/common";

class ComponentName extends AddFormProto {

    constructor(props) {
        super(props,  gd.const.project.type.BACKLOG);

        this._bind('onSubmit');

        const { template } = this.props;

        let copyOptions = [];
        if (template.templateContent) {
            const { events, subProjects, tasks } = template.templateContent;
            if (events)         copyOptions.push("events");
            if (subProjects)    copyOptions.push("subProjects");
            if (tasks)          copyOptions.push("tasks");
        }

        // FORM
        const initFormData = {
            company: gd.companyId,
            parentProject: this.initProjectId,
            name: '',
            owner: null, //gd.session.me.id,

            color: this.defaultColor,
            defaultView: template.defaultView,

            copyOptions: copyOptions,
        };

        const formStructure = {
            fields      : _.merge(newProject_getFormFieldsProto(this),{}),
            onSubmit    : this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);

    }

    onSubmit(result) {

        const { copyOptions } = result;

        const newProjectData = {

            toCompanyId: gd.companyId,
            toProjectId: result.parentProject,

            templateId: this.props.template.id,
            wipeTemplateContent: false, //!!this.props.template.wipeTemplateContent,
            name: result.name,
            // prefix: result.prefix,

            color: result.color,
            defaultView: result.defaultView,
            ownerUserId: result.owner,
            // deadline: result.deadline,

            copyTasks:          copyOptions.includes("tasks"),
            copySubProjects:    copyOptions.includes("subProjects"),
            copyEvents:         copyOptions.includes("events"),
        };

        const request = Api.Project.newProjectFromTemplate(newProjectData);

        request.done((data)=>{
            this.onProjectCreated(data);
        });
    }

    render() {
        const { advanced } = this.state;

        return (
            <Form form={this.form} submitBtnClass="grey">


                {this.renderAdvancedSwitch()}

                <div className="tbl">

                    {this.renderSelectParent()}

                    {this.renderNameAndColor()}

                    {advanced && this.renderOwner()}

                    {/*{advanced && this.renderDefaultView()}*/}

                </div>

            </Form>
        );

    }

}

module.exports = ComponentName;